export const GUEST_JWT_KEY = 'guest_jwt_token'
